<template>
  <svg
    fill="none"
    height="20"
    viewBox="0 0 20 20"
    width="20"
    xmlns="http://www.w3.org/2000/svg"
    @click="$emit('click')"
  >
    <path
      d="M3.10525 2.28867C2.98136 2.27111 2.85503 2.28483 2.7378 2.32858C2.62056 2.37233 2.51613 2.44471 2.43402 2.53915C2.35191 2.63358 2.29474 2.74705 2.26771 2.86923C2.24068 2.99141 2.24465 3.11842 2.27925 3.23867L3.69325 8.16367C3.78314 8.47669 3.97245 8.75196 4.2326 8.94788C4.49274 9.1438 4.80958 9.24973 5.13525 9.24967H11.2503C11.4492 9.24967 11.6399 9.32869 11.7806 9.46934C11.9212 9.60999 12.0003 9.80076 12.0003 9.99967C12.0003 10.1986 11.9212 10.3893 11.7806 10.53C11.6399 10.6707 11.4492 10.7497 11.2503 10.7497H5.13525C4.80958 10.7496 4.49274 10.8555 4.2326 11.0515C3.97245 11.2474 3.78314 11.5227 3.69325 11.8357L2.27925 16.7617C2.24465 16.8819 2.24068 17.0089 2.26771 17.1311C2.29474 17.2533 2.35191 17.3668 2.43402 17.4612C2.51613 17.5556 2.62056 17.628 2.7378 17.6718C2.85503 17.7155 2.98136 17.7292 3.10525 17.7117C8.80145 16.9026 14.1265 14.4116 18.3983 10.5577C18.4764 10.4873 18.5389 10.4014 18.5817 10.3053C18.6245 10.2093 18.6466 10.1053 18.6466 10.0002C18.6466 9.89503 18.6245 9.79107 18.5817 9.69502C18.5389 9.59898 18.4764 9.513 18.3983 9.44267C14.1264 5.58877 8.80143 3.09776 3.10525 2.28867Z"
      fill="#082655"
    />
  </svg>
</template>

<script>
export default {
  name: 'BlueSendIcon20'
};
</script>

<style scoped>

</style>
